import React, { useContext } from "react";
import { QuizContext } from "../../App";
import {
  ButtonSubmitQuizAct,
  ButtonSubmitQuizAndSaveAct,
  ButtonSubmitQuizAndSaveInAct,
  ButtonSubmitQuizInAct
} from "./ButtonsSubmitQuiz";


const ButtonsSubmitQuizTable = () => {

  const quizContext = useContext(QuizContext);

  return (
    <>
      {quizContext.state.currentUser === null
        || quizContext.state.errorMySQL === true
        || quizContext.state.errorAuth === true
        ? <>
          <div>
            <span style={{ fontWeight: "600" }}>
              ШАГ 5:</span> создайте квиз
          </div>
          <div className="sub-quiz">

            {quizContext.state.alertStatus === "changes confirmed"
              ? <ButtonSubmitQuizAct />
              : <ButtonSubmitQuizInAct />
            }

          </div>
        </>
        : <>
          <div>
            <span style={{ fontWeight: "600" }}>
              ШАГ 5:</span> создайте и сохраните квиз или создайте без сохранения
          </div>

          <div className="sub-quiz">
            {quizContext.state.alertStatus === "changes confirmed"
              ? <ButtonSubmitQuizAndSaveAct />
              : <ButtonSubmitQuizAndSaveInAct />
            }

            {quizContext.state.alertStatus === "changes confirmed"
              ? <ButtonSubmitQuizAct />
              : <ButtonSubmitQuizInAct />
            }
          </div>
        </>
      }
    </>
  )
}

export default ButtonsSubmitQuizTable